import React from "react";
import { DefaultLabel } from "../../components/DefaultLabel";

export function ErrorWidget(props) {
  const { ui } = props;
  const widgetId = ui.id;

  let content = "[ERROR in " + ui.widgetType + "]";

  const errorStyle = {
    height: "100%",
    width: "100%",
    border: "1px dashed grey",
    backgroundColor: "lightpink",
    padding: "0px 5px"
  };

  return (
    <div id={widgetId} style={errorStyle}>
      <DefaultLabel value={content} />
    </div>
  );
}